import { render, staticRenderFns } from "./branderAutho.vue?vue&type=template&id=b654f388&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./branderAutho.vue?vue&type=script&lang=js&"
export * from "./branderAutho.vue?vue&type=script&lang=js&"
import style0 from "./branderAutho.vue?vue&type=style&index=0&id=b654f388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b654f388",
  null
  
)

export default component.exports